import PublishToolbar from './PublishToolbar.gql';

export default PublishToolbar;
